import { render, staticRenderFns } from "./DashboardScreenManager.vue?vue&type=template&id=ccfedc4e&scoped=true&"
import script from "./DashboardScreenManager.vue?vue&type=script&lang=js&"
export * from "./DashboardScreenManager.vue?vue&type=script&lang=js&"
import style0 from "./DashboardScreenManager.scss?vue&type=style&index=0&id=ccfedc4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfedc4e",
  null
  
)

export default component.exports